export { CompanyIndustry } from './CompanyIndustry';
